import * as actionType from "../constants";
import * as commonData from "../Common";

export const fetAllBoards = (inputs) => async (dispatch) => {
  dispatch({ type: actionType.BOARD_LOADING });
  const apiurl = commonData.commonData().apiUrl;
  try {
    const response = await fetch(`${apiurl}boards`, {
      method: "post",
      body: JSON.stringify({ app_token: inputs }),
    });
    const rdata = await response.json();
    if (rdata.code === 200) {
      dispatch({ type: actionType.ALL_BOARDS, payload: rdata.data });
    } else {
      dispatch({ type: actionType.BOARD_ERROR });
    }
  } catch (error) {
    console.log(error);
    dispatch({ type: actionType.BOARD_ERROR });
  }
};

export const keepAllNameAndKey = (inputs) => (dispatch) => {
  dispatch({ type: actionType.KEEP_STORE_BOARD_DETAILS, payload: inputs });
};
